import { MEDIA } from "../i18n";
import Reveal from "./Reveal";

export default function YuanSection({ t }) {
  return (
    <section
      id="qhht"
      data-testid="yuan-section"
      className="relative py-28 md:py-40 bg-[#F5EFE6] overflow-hidden"
    >
      {/* Giant background glyph */}
      <div
        aria-hidden
        className="absolute -right-10 -top-10 font-chinese text-[28rem] leading-none text-[#F5E6C8] select-none pointer-events-none hidden md:block"
      >
        源
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <Reveal>
            <span className="overline" data-testid="yuan-overline">
              {t.yuan.overline}
            </span>
          </Reveal>
          <Reveal delay={120}>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05] text-[#3E362E] whitespace-pre-line"
              data-testid="yuan-title"
            >
              {t.yuan.title}
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="mt-8 text-[#5E554C] text-lg leading-relaxed font-light max-w-lg">
              {t.yuan.body}
            </p>
          </Reveal>

          <Reveal delay={320}>
            <div className="mt-12 img-frame aspect-[4/5] max-w-sm">
              <img src={MEDIA.mistMountain} alt="Misty mountain landscape" />
            </div>
          </Reveal>
          <Reveal delay={420}>
            <div className="mt-6 inline-flex flex-col items-start gap-3 border-l-2 border-[#C99A4E] pl-6">
              <span className="font-chinese text-7xl text-[#C99A4E] leading-none">
                源
              </span>
              <span className="overline">Yuan · Origin · 本源</span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-10 space-y-6">
          {t.yuan.pillars.map((p, i) => (
            <Reveal key={p.title} delay={i * 140}>
              <div
                className="border-t border-[#CEBFAA] pt-8 pb-4 flex flex-col md:flex-row md:items-baseline gap-4 md:gap-10"
                data-testid={`yuan-pillar-${i}`}
              >
                <span className="section-number w-12 shrink-0">0{i + 1}</span>
                <div className="flex-1">
                  <h3 className="font-serif text-3xl md:text-4xl text-[#3E362E] mb-3">
                    {p.title}
                  </h3>
                  <p className="text-[#5E554C] text-base md:text-lg font-light leading-relaxed max-w-xl">
                    {p.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal delay={560}>
            <div className="mt-10 bg-[#FDFBF7] border border-[#E8E1D9] grid grid-cols-1 md:grid-cols-5 overflow-hidden">
              <div className="md:col-span-2 img-frame aspect-square md:aspect-auto min-h-[260px]">
                <img src={MEDIA.lotus} alt="Misty mountains at golden dawn" />
              </div>
              <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center">
                <span className="overline">Dolores Cannon · 1931 – 2014</span>
                <p className="font-serif italic text-xl md:text-2xl text-[#3E362E] mt-4 leading-snug">
                  "El subconsciente tiene todas las respuestas. Solo hay que saber preguntar."
                </p>
                <div className="mt-5 flex items-center gap-3">
                  <span className="h-px w-12 bg-[#C99A4E]" />
                  <span className="font-chinese text-xl text-[#C99A4E]">源</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
